import { useEffect, useState } from 'react';

import { useVisualization } from '@/context/visualization-context';
import { WindowLevelService, type WindowLevel } from '@/visualization/services/window-level-service';

/**
 * Thin bridge to the global WindowLevelService. Subscribes to WINDOW_LEVEL_CHANGED
 * and returns the live window/level value.
 *
 * The service is global — a single W/L applies to all viewports — so every consumer
 * of this hook observes the same value, updating live during drags and preset preview.
 */
export function useWindowLevel(): WindowLevel {
    const { getServiceManager } = useVisualization();
    const [windowLevel, setWindowLevel] = useState<WindowLevel>(() =>
        getServiceManager().getService<WindowLevelService>(WindowLevelService.SERVICE_NAME).getWindowLevel()
    );

    useEffect(() => {
        const service = getServiceManager().getService<WindowLevelService>(WindowLevelService.SERVICE_NAME);
        setWindowLevel(service.getWindowLevel());

        return service.subscribe<WindowLevel>(service.EVENTS.WINDOW_LEVEL_CHANGED, (wl) => {
            setWindowLevel(wl);
        });
    }, [getServiceManager]);

    return windowLevel;
}
